import Enum from './Enum';

export default class UserStatus extends Enum {
    static INTERIM = new UserStatus('INTERIM', '仮登録');
    static ACTIVE = new UserStatus('ACTIVE', '利用中');
    static INACTIVE = new UserStatus('INACTIVE', '利用停止中');
    static ARCHIVED = new UserStatus('ARCHIVED', 'アーカイブ済');
}
